import { CALL_CHANNEL } from "./common.constants";

// Values for journey/productGroup
// can also be used as accessors for route.constants graph
export const LANDLORDS = "LANDLORDS";
export const HOME = "HOME";
export const TENANTS_CONTENTS = "TENANTS_CONTENTS";
export const TENANTS_LIABILITY = "TENANTS_LIABILITY";
export const MPPI = "MPPI";
// Question Set Metadata
export const QS_IDS = [
  {
    id: 117,
    productId: 1003,
    isAdvised: false,
    isVc: false,
    questions: "rqs",
    application: "rqs",
    journey: MPPI,
  },
  {
    id: 181,
    productId: 1003,
    isAdvised: false,
    isVc: false,
    questions: "rqs",
    application: "rqs",
    journey: MPPI,
  },
  {
    id: 180,
    productId: 1010,
    isAdvised: false,
    isVc: false,
    questions: "rqs",
    application: "rqs",
    journey: TENANTS_LIABILITY,
  },
  {
    id: 179,
    productId: 1014,
    isAdvised: false,
    isVc: false,
    questions: "rqs",
    application: "rqs",
    journey: TENANTS_CONTENTS,
    isRollingMonthly: true,
  },
  {
    // Tenants contents B2B
    id: 159,
    productId: 1014,
    isAdvised: true,
    isVc: false,
    brand: "quilter",
    questions: "rqs_advised",
    application: "rqs_advised",
    journey: TENANTS_CONTENTS,
    isRollingMonthly: true,
  },
  {
    // LL D2C
    id: 176,
    productId: 1009,
    callChannel: CALL_CHANNEL.referralSelfServe,
    isAdvised: false,
    isVc: false, // D2C implements its own payment options
    questions: "d2c",
    application: "d2c",
    journey: LANDLORDS,
  },
  {
    // LL VC B2B
    id: 176,
    productId: 1009,
    isAdvised: false,
    isVc: true,
    questions: "rqs",
    application: "rqs",
    journey: LANDLORDS,
  },
  {
    // LL VC Advised (Non FF)
    id: 177,
    productId: 1009,
    isAdvised: true,
    isVc: true,
    questions: "rqs",
    application: "rqs",
    journey: LANDLORDS,
  },
  {
    // LL VC Quilter
    id: 178,
    productId: 1009,
    isAdvised: false,
    isVc: true,
    brand: "quilter",
    questions: "rqs",
    application: "rqs",
    journey: LANDLORDS,
  },
  {
    // LL D2C
    id: 137,
    productId: 1009,
    callChannel: CALL_CHANNEL.referralSelfServe,
    isAdvised: false,
    isVc: false, // D2C implements its own payment options
    questions: "d2c",
    application: "d2c",
    journey: LANDLORDS,
  },
  {
    // LL D2C
    id: 176,
    productId: 1009,
    callChannel: CALL_CHANNEL.referralSelfServe,
    isAdvised: false,
    isVc: false, // D2C implements its own payment options
    questions: "d2c",
    application: "d2c",
    journey: LANDLORDS,
  },
  {
    // LL VC B2B
    id: 137,
    productId: 1009,
    isAdvised: false,
    isVc: true,
    questions: "rqs",
    application: "rqs",
    journey: LANDLORDS,
  },
  {
    // LL VC Advised
    id: 138,
    productId: 1009,
    isAdvised: true,
    isVc: true,
    questions: "rqs",
    application: "rqs",
    journey: LANDLORDS,
  },
  {
    // LL STD Advised?
    id: 139,
    productId: 1009,
    isAdvised: true,
    isVc: false,
    questions: "rqs",
    application: "rqs",
    journey: LANDLORDS,
  },
  {
    // LL Quilter
    id: 140,
    productId: 1009,
    isAdvised: false,
    isVc: true,
    brand: "quilter",
    questions: "rqs",
    application: "rqs",
    journey: LANDLORDS,
  },
  {
    // HJO D2C
    id: 157,
    productId: 1008,
    callChannel: CALL_CHANNEL.referralSelfServe,
    isAdvised: false,
    isVc: false, // D2C implements its own payment options
    questions: "d2c",
    application: "d2c",
    journey: HOME,
  },
  {
    // HJO VC Broker
    id: 157,
    productId: 1008,
    isAdvised: false,
    isVc: true,
    questions: "rqs",
    application: "rqs",
    journey: HOME,
  },
  {
    // HJO VC Advised
    id: 160,
    productId: 1008,
    isAdvised: true,
    isVc: true,
    questions: "rqs",
    application: "rqs_advised",
    journey: HOME,
  },
  {
    // HJO STD Broker
    id: 161,
    productId: 1008,
    isAdvised: false,
    isVc: false,
    questions: "rqs",
    application: "rqs",
    journey: HOME,
  },
  {
    // HJO STD Advised
    id: 162,
    productId: 1008,
    isAdvised: true,
    isVc: false,
    questions: "rqs",
    application: "rqs_advised",
    journey: HOME,
  },
  {
    // HJO VC Quilter
    id: 163,
    productId: 1008,
    isAdvised: false,
    isVc: true,
    brand: "quilter",
    questions: "rqs",
    application: "rqs",
    journey: HOME,
  },
  {
    // HJO STD Quilter
    id: 164,
    productId: 1008,
    isAdvised: false,
    isVc: false,
    brand: "quilter",
    questions: "rqs",
    application: "rqs",
    journey: HOME,
  },
  {
    // HPR STD Broker
    id: 166,
    productId: 1015,
    isAdvised: false,
    isVc: false,
    questions: "hpr",
    application: "hpr",
    journey: HOME,
  },
  {
    // HPR VC Broker
    id: 167,
    productId: 1015,
    isAdvised: false,
    isVc: true,
    questions: "hpr",
    application: "hpr",
    journey: HOME,
  },
  {
    // HPR D2C
    id: 167,
    productId: 1015,
    callChannel: CALL_CHANNEL.referralSelfServe,
    isAdvised: false,
    isVc: false, // D2C implements its own payment options
    questions: "hpr_d2c",
    application: "hpr_d2c",
    journey: HOME,
  },
  {
    // HPR STD Advised
    id: 168,
    productId: 1015,
    isAdvised: true,
    isVc: false,
    questions: "hpr",
    application: "hpr_advised",
    journey: HOME,
  },
  {
    // HPR VC Advised
    id: 169,
    productId: 1015,
    isAdvised: true,
    isVc: true,
    questions: "hpr",
    application: "hpr_advised",
    journey: HOME,
  },
  {
    // HPR Quilter STD
    id: 170,
    productId: 1015,
    isAdvised: false,
    isVc: false,
    brand: "quilter",
    questions: "hpr",
    application: "hpr",
    journey: HOME,
  },
  {
    // HPR Quilter VC
    id: 171,
    productId: 1015,
    isAdvised: false,
    isVc: true,
    brand: "quilter",
    questions: "hpr",
    application: "hpr",
    journey: HOME,
  },
];

// Question Set Overrides
const adviserOverrides = [
  {
    Id: 0,
    Text: "Basis of Advice",
    Value: "Advised",
    Options: [
      {
        Text: "Advised",
        Value: "Advised",
        DataUiid: "BasisOfAdvice_Advised",
      },
    ],
    DataUiid: "BasisOfAdvice",
    HelpText: "",
    IsVisible: true,
    Conditions: [],
    Validation: {
      Rules: ["ruleRequired"],
    },
    DisplayType: "Question",
    InterfaceKey: "BasisOfAdvice",
    AnswerControlType: "SelectBase",
    RelatedQuestionId: [],
  },
  {
    Id: 1,
    Text: "Policy Start Date (optional)",
    Value: "",
    DataUiid: "PolicyStartDate",
    HelpText: "",
    IsVisible: true,
    Conditions: [],
    Validation: {
      Rules: ["ruleRegexFormat", "ruleDateValid", "rulePolicyStartDate"],
      RuleProperties: {
        DateValid: {
          ErrorMsg: "Must be a valid date.",
        },
        RegexFormat: {
          Value: "^\\s*$|^(\\d{2})\\/(\\d{2})\\/\\d{4}$",
          ErrorMsg: "Date is not valid.",
        },
        PolicyStartDate: {
          ErrorMsg: "Policy start date must be between today and ",
        },
      },
    },
    DisplayType: "Question",
    InterfaceKey: "PolicyStartDate",
    AnswerControlType: "QuestionDate",
    RelatedQuestionId: [],
    AnswerControlAttributeType: "text",
  },
];

const vcOverrides = [
  {
    Id: 101,
    Text: "Payment frequency",
    Value: "",
    Options: [
      {
        Text: "Annual",
        Value: "Annual",
        DataUiid: "PaymentFrequency_Annual",
      },
      {
        Text: "Monthly",
        Value: "Monthly",
        DataUiid: "PaymentFrequency_Monthly",
      },
      {
        Text: "Monthly - 9 Monthly Payment Option",
        Value: "Monthly3MonthsDeferred",
        DataUiid: "PaymentFrequency_Monthly3MonthsDeferred",
      },
    ],
    DataUiid: "PaymentFrequency",
    HelpText: "",
    IsVisible: false,
    Conditions: ["DirectDebit"],
    Validation: {
      Rules: ["ruleRequired"],
    },
    DisplayType: "Question",
    InterfaceKey: "PaymentFrequency",
    AnswerControlType: "SelectToggleHiddenQuestion",
    RelatedQuestionId: [100],
  },
  {
    Id: 102,
    Text: "Repayment Confirmation",
    Value: "",
    DataUiid: "RepaymentConfirmation",
    HelpText: "",
    IsVisible: false,
    Conditions: ["Monthly", "Monthly3MonthsDeferred"],
    Validation: {
      Rules: ["ruleRequired"],
    },
    DisplayType: "Question",
    InterfaceKey: "RepaymentConfirmation",
    AnswerControlType: "CheckboxBase",
    AnswerControlLabel:
      "I confirm that I have read, understood and agreed to the above statement.",
    RelatedQuestionId: [101],
  },
];

export const QUESTION_SET_OVERRIDES = [
  {
    isVc: true,
    overrides: [...vcOverrides],
  },
  {
    callChannel: CALL_CHANNEL.referralTelephony,
    overrides: [...adviserOverrides],
  },
  {
    branchNumber: "ADVISED",
    overrides: [...adviserOverrides],
  },
  {
    branchNumber: "PSDEFERRED",
    overrides: [...adviserOverrides],
  },
  {
    branchNumber: "PS296036", // Colleague discount
    overrides: [...adviserOverrides],
  },
  {
    branchNumber: "PS296037", // Friend discount
    overrides: [...adviserOverrides],
  },
];

export const QUESTIONS = {
  mortgageCategory: {
    interfaceKey: "ResidentialStatus",
    options: {
      firstTimeBuyer: {
        interfaceKey: "FirstTimeBuyer",
      },
    },
  },
};

export const LANDLORD_PREPARED_ANSWERS = [
  {
    InterfaceKey: "DirectTenancyAgreement",
    Value: true,
  },
  {
    InterfaceKey: "BusinessPurposes",
    Value: false,
  },
  {
    InterfaceKey: "Subsidence",
    Value: false,
  },
  {
    InterfaceKey: "Convictions",
    Value: false,
  },
  {
    InterfaceKey: "InsuranceDeclines",
    Value: false,
  },
  {
    InterfaceKey: "MoreThanSixIndividuals",
    Value: false,
  },
  {
    InterfaceKey: "SelfContainedUnits",
    Value: false,
  },
  {
    InterfaceKey: "Flooding",
    Value: false,
  },
];
